/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Created_LabelInputs */



/**
* | output |
* | --- |
* | "Created:" |
*
* @param {Knp_Guide_Created_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_created_label = /** @type {((inputs?: Knp_Guide_Created_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Created_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créé :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creato:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Созданный:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creado:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建时间：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成日:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बनाया था:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criado:")
	return /** @type {LocalizedString} */ ("Created:")
});